module.exports = __webpack_public_path__ + "img/create_label.98bed316.svg";